const fetchAreas = {
  text: 'Nenhum resultado encontrado'
}

export default fetchAreas;
